import { KEY_ALT_LEFT, KEY_ALT_RIGHT } from '@/constants';

export default event => {
  return event.altKey || [KEY_ALT_LEFT, KEY_ALT_RIGHT].includes(event.code);
};
